'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Front = _interopRequireDefault(require("Layouts/Front"));
var _Image = _interopRequireDefault(require("Pure/Image"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _RecrutementIcon = _interopRequireDefault(require("Icons/RecrutementIcon"));
var _FormationIcon = _interopRequireDefault(require("Icons/FormationIcon"));
var _MaintienEmploiIcon = _interopRequireDefault(require("Icons/MaintienEmploiIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
let app = window.app;
class PreparationEmploiPage extends _react.Component {
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let output = /*#__PURE__*/_react.default.createElement(_Front.default, _extends({
      page_title: "Accueil | AspieJob"
    }, props), /*#__PURE__*/_react.default.createElement("div", {
      className: "o-content"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidat-project"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidat-project__column c-candidat-project__column--txt"
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/recruteurs"
    }, "Recruteurs"), "/ ", /*#__PURE__*/_react.default.createElement("span", {
      className: "blue-text"
    }, "Pr\xE9paration Op\xE9rationnelle \xE0 l\u2019Emploi")), /*#__PURE__*/_react.default.createElement("h1", {
      className: "c-title"
    }, "Pr\xE9paration Op\xE9rationnelle \xE0 l\u2019Emploi"), /*#__PURE__*/_react.default.createElement("p", null, "Une expertise professionnelle pour recruter et int\xE9grer dans votre entreprise les talents des personnes autistes Asperger."), /*#__PURE__*/_react.default.createElement(_Link.default, {
      className: "c-btn c-btn--orange u-margin-top-40",
      href: "/inscription-entreprise"
    }, "Inscrivez-vous gratuitement")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidat-project__column c-candidat-project__column--img"
    }, /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: "/images/aspiejob-employeurs.svg",
      className: "c-candidat-project_img"
    }))), /*#__PURE__*/_react.default.createElement("h2", {
      className: "c-title c-title--medium u-text-center u-margin-top-40"
    }, "Mettre en place une \xAB Pr\xE9paration Op\xE9rationnelle \xE0 l\u2019Emploi \xBB pour former et recruter des collaborateurs pour un besoin op\xE9rationnel sp\xE9cifique :"), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidat-project c-candidat-project--poe"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidat-project__column c-candidat-project__column--img"
    }, /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: "/images/deposervotreoffre.svg",
      className: "c-candidat-project_img"
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidat-project__column c-candidat-project__column--txt"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "c-circle-decoration c-circle-decoration--blue"
    }, "Nous aidons l\u2019entreprise \xE0 d\xE9finir ses besoins en recrutement de collaborateurs \xE0 former."), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-circle-decoration c-circle-decoration--orange"
    }, "Nous proposons une entreprise de formation qui va pouvoir coordonner l\u2019intervention de l\u2019OPCO (Op\xE9rateurs de Comp\xE9tence), de P\xF4le Emploi ainsi que de l\u2019AGEFIPH pour le financement."), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-circle-decoration c-circle-decoration--green"
    }, "Nous b\xE2tissons le projet p\xE9dagogique avec l\u2019entreprise et l\u2019entreprise de formation et nous l\u2019adaptons aux besoins particuliers des Asperger."), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-circle-decoration c-circle-decoration--pink"
    }, "Nous sour\xE7ons les candidats titulaires d\u2019une RQTH (Reconnaissance de Qualit\xE9 de Travailleur Handicap\xE9) gr\xE2ce \xE0 notre r\xE9seau et \xE0 notre site internet www.aspiejob.org. Nous validons, en collaboration avec l\u2019entreprise et l\u2019entreprise de formation, qu\u2019ils peuvent entamer le parcours de la POE."), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-circle-decoration c-circle-decoration--orange"
    }, "Nous accompagnons les candidats pendant la formation pour en assurer le succ\xE8s et les pr\xE9parer \xE0 int\xE9grer les postes propos\xE9s."), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-circle-decoration c-circle-decoration--blue"
    }, "Enfin, nous d\xE9ployons notre mod\xE8le d\u2019int\xE9gration dans l\u2019emploi."))), /*#__PURE__*/_react.default.createElement("h2", {
      className: "c-title c-title--medium u-text-center u-margin-top-40"
    }, "Ce que nous vous proposons \xE9galement"), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-parcours-grid c-parcours-grid--4"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/recrutement-et-integration",
      className: "c-parcours-grid-item c-parcours-grid-item--green"
    }, /*#__PURE__*/_react.default.createElement(_RecrutementIcon.default, {
      className: "c-parcours-grid-item__icon"
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-parcours-grid-item__txt"
    }, "Recrutement et int\xE9gration de candidats"), /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/recrutement-et-integration",
      className: "c-parcours-grid-item__link"
    }, "En savoir plus")), /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/formation-sensibilisation",
      className: "c-parcours-grid-item c-parcours-grid-item--blue"
    }, /*#__PURE__*/_react.default.createElement(_FormationIcon.default, {
      className: "c-parcours-grid-item__icon"
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-parcours-grid-item__txt"
    }, "Formations & Sensibilisation"), /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/formation-sensibilisation",
      className: "c-parcours-grid-item__link"
    }, "En savoir plus")), /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/maintien-emploi",
      className: "c-parcours-grid-item c-parcours-grid-item--pink"
    }, /*#__PURE__*/_react.default.createElement(_MaintienEmploiIcon.default, {
      className: "c-parcours-grid-item__icon"
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-parcours-grid-item__txt"
    }, "Maintien en emploi"), /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/maintien-emploi",
      className: "c-parcours-grid-item__link"
    }, "En savoir plus")))));
    return output;
  }
}
exports.default = PreparationEmploiPage;
